/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface UpdateAccountDomains$Request {
    accountId: number;
    requestBody: Array<string>;
}

export interface UpdateAccountDomains$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountDomainsRequest = createAction<PayloadData<void, UpdateAccountDomains$Request>>('UPDATE_ACCOUNT_DOMAINS__UPDATE_ACCOUNT_DOMAINS__REQUEST');
export const updateAccountDomainsSuccess = createAction<PayloadData<void, UpdateAccountDomains$Request>>('UPDATE_ACCOUNT_DOMAINS__UPDATE_ACCOUNT_DOMAINS__SUCCESS');
export const updateAccountDomainsFailure = createAction<PayloadData<Error, UpdateAccountDomains$Request, true>>('UPDATE_ACCOUNT_DOMAINS__UPDATE_ACCOUNT_DOMAINS__FAILURE');

export const updateAccountDomainsActions = [
    updateAccountDomainsRequest,
    updateAccountDomainsSuccess,
    updateAccountDomainsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountDomains = (meta: UpdateAccountDomains$Request, config?: UpdateAccountDomains$Config) => {
    return {
        CALL_API: {
            types: updateAccountDomainsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/domains`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

